// external modules

// internal modules

// state

// components
// styles & types & assets
import styles from "./FixedContainer.module.scss";
import classNames from "classnames/bind";
import { colorInfo } from "utils/constants/colorInfo";
const cn = classNames.bind(styles);

type TPosition = "top" | "bottom";
type TBackgroundColor = "etcGrayLight";
export default function FixedContainer({
  children,
  position,
  isHeaderOrNavExist,
  background,
}: {
  children: React.ReactNode;
  position: TPosition;
  isHeaderOrNavExist: boolean;
  background?: TBackgroundColor;
}) {
  return (
    <div
      className={cn("wrapper-fixedContainer", {
        top: position === "top",
        bottom: position === "bottom",
      })}
      data-is-header-or-nav-exist={isHeaderOrNavExist}
      style={{ background: background && colorInfo[background] }}
    >
      {children}
    </div>
  );
}
